import React from 'react'
import moment from 'moment'

export const COLUMNS_REPORTE_EMBARQUE_SECTOR_12_LINEA_5 = [
  {
    name: 'silo',
    label: 'Silo',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'etiqueta',
    label: 'Condición',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'fechaInicioLlenado',
    label: 'Ensilado',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => value ? <>{moment(value).format('DD/MM/YYYY')}</> : null
    }
  },
  {
    name: 'pesoNetoBaseVigente',
    label: 'Existencia [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '70%' }}>
            {(value !== null && value !== undefined) ? `${parseFloat(value).toFixed(2)}` : 0}
          </div>
        )
      }
    }
  },
  {
    name: 'vejezSilo',
    label: 'Vejez [días]',
    options: {
      filter: true,
      sort: true
    }
  }
]
export const COLUMNS_REPORTE_EMBARQUE_SECTOR_12_LINEA_5_TO_PRINT = [
  {
    name: 'silo',
    label: 'Silo',
    width: 40,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'etiqueta',
    label: 'Etiqueta',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'fechaInicioLlenado',
    label: 'Ensilado',
    width: 90,
    mantenerCase: true
  },
  {
    name: 'pesoNetoBaseVigente',
    label: 'Toneladas',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'vejezSilo',
    label: 'Vejez [días]',
    width: 60,
    mantenerCase: true
  }
]
